/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        var menuLinkAttr = function () {
          $('#menu-main-menu li a').each(function(){
             var txt = $(this).text();
             $(this).attr( "title", txt );


          });
        };
        menuLinkAttr();


        var menuShrink = function() {
          // Menu functions
          var baseUrl = document.location.origin;
      
          $(window).scroll(function() {
            if ($(document).scrollTop() > 50) {
                $('header.header').addClass('shrink');
                //$('a.brand').addClass('colour');
            } else {
                $('header.header').removeClass('shrink');
                //$('a.brand').removeClass('colour');
            }
          });
        
        };
        menuShrink();


        var mobileMenu_btn = function () {
            $('#mobile-menu__btn').click(function(){
              $(this).toggleClass('active');
              $('.header__wrapper').toggleClass('no_shadow');
              $('.mobile-menu').slideToggle();
            });
        };

        mobileMenu_btn();


        var tabsParentSelector = function() {
          $('.nav-tabs li.nav-item a').each(function(){
            $(this).click(function(){
              $(this).parent().siblings('li').removeClass('li-active');
              $(this).parent().addClass('li-active');
            });
          });
        };

        tabsParentSelector();


        // Timeline
        var module_timeline = $('.module-timeline');
        var timeline = function() {
          // Navigation
          $('.module-timeline__nav-year-list').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.module-timeline__event',
            arrows: true,
            dots: false,
            centerMode: true,
            swipeToSlide: false,
            infinite: false,
            focusOnSelect: true,
            responsive: [ 
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  centerMode: false,
                }
              }
            ]
          });
          // Events
           $('.module-timeline__event').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            //centerPadding: $('.module-timeline__event').find('.module-timeline__event-single').outerWidth() / 2,
            arrows: false,
            //fade: true,
            infinite: false,
            centerMode: true,
            asNavFor: '.module-timeline__nav-year-list'
          });
        };

        if(module_timeline.length) {
          timeline();
        }

         // Testimonial slider
        var module_testimonial = $('.module-testimonial');
        var testimonial = function() {
           $('.module-testimonial__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            responsive: [ 
              {
                breakpoint: 992,
                settings: {
                  arrows: false
                }
              }
            ]
          });
        };

        if(module_testimonial.length) {
          testimonial();
        }


        // raido button animation
        var radios = $('.project-form__radio');
        var radioAction = function() {
          $('.wpcf7-list-item input').each(function(){
            $(this).on('click',function(){
              $('.project-form__radio .wpcf7-list-item-label').removeClass('selected');
              $(this).siblings('.wpcf7-list-item-label').addClass('selected');
            });
          });
        };
        if(radios.length) {
          radioAction();
        }

        // Team member
        var module_team = $('.module-accordion');
        var accordion = function() {


          $('.module-team__member-wrap').each(function(){
            $(this).on('click',function(event){
              event.stopPropagation();
              //alert('hey');
              if ($(this).hasClass('module-team__member-close')) {
                $(this).find('.module-team__member-profile').slideDown();
                $(this).find('.profile-trigger').addClass('up');
                $(this).find('i.fal').removeClass('fa-chevron-down');
                $(this).find('i.fal').addClass('fa-chevron-up');
                $(this).removeClass('module-team__member-close');
              }
            });
          });

         //$('.profile-trigger.up').each(function(){
          $('.profile-trigger').on('click',function(event){
            if($(this).hasClass('up')) {
              event.stopPropagation();
              $(this).parents('.module-team__member-wrap').addClass('module-team__member-close');
              $(this).parents('.module-team__member-head').next('.module-team__member-profile').slideUp();
              $(this).removeClass('up');
              $(this).find('i.fal').removeClass('fa-chevron-up');
              $(this).find('i.fal').addClass('fa-chevron-down');
            }
          });           
        };

        if(module_team.length) {
          accordion();
        }

        // Vertical slider
        var module_partner = $('.module-project-partner');
        var verticalSlider = function() {

          $('.vertical-slider').slick({
             accessibility: false,
             dots: false,
             arrow: true,
             vertical: true,
             verticalSwiping: true,
             slidesToShow: 1,
             slidesToScroll: 1,
             infinite: false,
             centerMode: true,
             focusOnSelect: true,
             centerPadding: '57px',
             asNavFor: '.vertical-slider-content'
          });

          $('.vertical-slider-content').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.vertical-slider',
            dots: false,
            infinite: false,
            fade: true,
            cssEase: 'linear'
          });

          $('.vertical-mobile-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            // fade: true,
            // cssEase: 'linear'
          });

        };

        if(module_partner.length) {
          verticalSlider();
        }

        // How we work slider 
        var module_work_steps = $('.module-project-steps');
        var howWeWorkSlider = function() {

          $('.how-we-work-slider').slick({
             dots: true,
             arrow: true,
             slidesToShow: 1,
             slidesToScroll: 1,
             infinite: false,
             centerMode: true,
             centerPadding: '15%',
          });
        };

        if(module_work_steps.length) {
          howWeWorkSlider();
        }

        var module_network = $('.module-network__bg-slider');
        if (module_network.length) {
          $('.module-network__bg-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            infinite: true,
            fade: true,
            autoplay: true,
            autoplaySpeed: 4000,
            cssEase: 'linear'
          });

          $('.bg-slider-nav-left').click(function(){
                $('.module-network__bg-slider').slick('slickPrev');
          });

          $('.bg-slider-nav-right').click(function(){
                $('.module-network__bg-slider').slick('slickNext');
          });

        }



        // ==============================================================
        // CAREER LOCATION FILTER =======================================
        // ==============================================================
        var career_list_filter = function() {


          function career_getURLParameter(sParam){
            var sPageURL = window.location.search.substring(1);
            var sURLVariables = sPageURL.split('&');
            for (var i = 0; i < sURLVariables.length; i++) 
            {
                var sParameterName = sURLVariables[i].split('=');
                if (sParameterName[0] === sParam)
                {
                    return sParameterName[1];
                }
            }
          }

          
           function load_careers_data(){
            
            var ajaxurl = '/wp-admin/admin-ajax.php';

            //alert(jobType_var);
            
            // alert(jobType_filter);
            // location_filter = $('#selected-location').val();

            var data = {
              locationData: jobLocation,
              lang: currentLang,
              action: "load-careers-data"
            };

            //console.log(data);
            
            
            $.post(ajaxurl, data, function(response) {
              $response = $(response);

              $response.hide();
              $(".career-list_result").append($response);
              $response.fadeIn(500, function(){
                loading = false;
              });
              
              loading = false;
              
            });

          }


          // Initialte the dropdown click
          function initJobLocation(){
            
            $('.career-list-dropdown a').each(function(){
              $(this).click(function(){
                
                //jobLocation = '';
                jobLocation = $(this).data('slug');

                // alert(jobLocation);

                //URL config
                var url = full_url;
                var button_txt = $(this).text();

                $('#career-list-btn').html($(this).text());
                
                // if(jobType !== ''){
                //   url = url + '?type=' + jobType;
                // }
                
                history.pushState('','', url);
                $(".career-list_result").html('');
                
                // set_dropdown_txt();
                load_careers_data();

              }); 
            });

          }

          initJobLocation();

        };

        career_list_filter();





        // ==============================================================
        // MEDIA TAB AJAX =========================================
        // ==============================================================
        var mediaTab_ajax = function() {
            
            var first_load = true;
            var catID = '';
            var page = 1;
            var year = '';
            var result_target = '';

            function load_posts(catID, page, result_target, year){

              $('.desktop-loading').show();

                var ajaxurl = '/wp-admin/admin-ajax.php';

                var data = {
                  dataType: 'json',
                  page: page,
                  per_page : 6,
                  cat_id: catID,
                  cat_year: year,
                  cat_slug: result_target,
                  action: "load-media-posts",
                  success: function() {
                    //alert('loaded');
                  }
                };
                
                $.post(ajaxurl, data, function(response) {

                  $('#' + result_target).html('');
                  $response = $(response);
                  $response.hide();
                  $('#' + result_target).append($response);
                  $response.fadeIn(500, function(){
                    loading = false;
                  });
                
                }).done(function(){
                   $('.desktop-loading').hide();
                }).fail (function(jqxhr, textStatus, errorThrown)  {
                    $('.desktop-loading').hide();
                    console.log("Error: " + textStatus + " : " + errorThrown) ;
                });

          } 

          // Pagination ================================================================

          function paginationInit(catID, page, result_target, year) {

              //$('.module-tabs__content-media .tab-content__nav-arrow-left').each(function(){
              $('#' + result_target ).unbind("click").on('click', '.tab-content__nav-arrow-left', function() {

                    //alert(year);
                    $('#' + result_target ).empty();

                    page--;
                    $('#' + result_target).attr('data-page', page);

                    load_posts(catID, page, result_target, year);
                    $(this).siblings('.tab-content__nav-index').find('.index-page').text(page);

                });
              

              $('#' + result_target ).on('click', '.tab-content__nav-arrow-right', function() {

                    //alert(year);
                    $('#' + result_target ).empty();

                    page++;
                    $('#' + result_target).attr('data-page', page);
                    
                    load_posts(catID, page, result_target, year);
                    $(this).siblings('.tab-content__nav-index').find('.index-page').text(page);

                });
              

          }

          // Load content for each tab when the page is loaded
          $('.media-tab-result').each(function(){

            catID = $(this).attr('data-cat-id');
            page = $(this).attr('data-page');
            result_target = $(this).attr('id');

            //load_posts(catID, page, result_target, year);
            paginationInit(catID, page, result_target, year);
          });

          // Year filtering
          function yearFilter() {

            $('.year-filter-desktop .module-tabs__year-filter-dropdown a').each(function(){
              var yearBtn = $(this);
              yearBtn.on('click', function(){
                
                year = yearBtn.attr('data-year');
                //page = 1;

                if(year && year !=="") {
                  $('.year-filter-desktop .module-tabs__year-filter-btn').html(year);
                } else {
                  if ( $('html').attr('lang') === 'zh-hant') {
                    $('.year-filter-desktop .module-tabs__year-filter-btn').html('全部');
                  } else {
                    $('.year-filter-desktop .module-tabs__year-filter-btn').html('ALL');  
                  }
                }

                $('.media-tab-result').each(function(){
                  var tab = $(this);
                  catID = tab.attr('data-cat-id');
                  $('.media-tab-result').attr('data-page', '1');
                  // console.log(page);
                  page = 1;
                  result_target = tab.attr('id');

                  $('.media-tab-result').empty();

                  load_posts(catID, page, result_target, year);
                  paginationInit(catID, page, result_target, year);
                });

              });


            });

          }
          yearFilter();

        };
        mediaTab_ajax();


        // ==============================================================
        // MEDIA TAB PAGINATION MOBILE ==================================
        // ==============================================================
        var mediaTab_accordion_pagination = function() {
            
            var first_load = true; 
            var catID = '';
            var page = 1;
            var year = '';
            var result_target = '';

            function load_posts_mobile(catID, page, result_target, year){

                $('#' + result_target).siblings('.mobile-loading').show();

                var ajaxurl = '/wp-admin/admin-ajax.php';

                var data = {
                  page: page,
                  per_page : 3,
                  cat_id: catID,
                  cat_year: year,
                  cat_slug: result_target,
                  action: "load-media-posts-mobile"
                };
                
                $.post(ajaxurl, data, function(response) {

                    $('#' + result_target).html('');
                    $response = $(response);
                    $response.hide();
                    $('#' + result_target).append($response);
                    $response.fadeIn(500, function(){
                      loading = false;
                    });

                  }).done(function(){
                   $('.mobile-loading').hide();
                  }).fail (function(jqxhr, textStatus, errorThrown)  {
                      $('.mobile-loading').hide();
                      console.log("Error: " + textStatus + " : " + errorThrown) ;
                  });
          }

          function paginationInit_mobile(catID, page, result_target, year) {

              //$('.module-tabs__content-media .tab-content__nav-arrow-left').each(function(){
              $('#' + result_target ).unbind("click").on('click', '.tab-content__nav-arrow-left', function() {

                    //alert(year);
                    $("html, body").animate({ scrollTop: $('#' + result_target ).offset().top - 200}, 500);

                    $('#' + result_target ).empty();

                    page--;
                    $('#' + result_target).attr('data-page', page);

                    load_posts_mobile(catID, page, result_target, year);
                    $(this).siblings('.tab-content__nav-index').find('.index-page').text(page);

                });
              

              $('#' + result_target ).on('click', '.tab-content__nav-arrow-right', function() {

                    //alert(year);
                    $("html, body").animate({ scrollTop: $('#' + result_target ).offset().top - 200}, 500);

                    $('#' + result_target ).empty();

                    page++;
                    $('#' + result_target).attr('data-page', page);
                    
                    load_posts_mobile(catID, page, result_target, year);
                    $(this).siblings('.tab-content__nav-index').find('.index-page').text(page);

                });
              

          }

          // Load content for each card when the page is loaded
          $('.media-card-result').each(function(){

            catID = $(this).attr('data-cat-id');
            page = $(this).attr('data-page');
            result_target = $(this).attr('id');

            //load_posts_mobile(catID, page, result_target, year);
            paginationInit_mobile(catID, page, result_target, year);
          });

          // Year filtering
          function yearFilter() {

            $('.year-filter-mobile .module-tabs__year-filter-dropdown a').each(function(){
              var yearBtn = $(this);
              yearBtn.on('click', function(){
                
                year = yearBtn.attr('data-year');
                //page = 1;

                if(year && year !=="") {
                  $('.year-filter-mobile .module-tabs__year-filter-btn').html(year);
                } else {
                  
                  if ( $('html').attr('lang') === 'zh-hant') {
                    $('.year-filter-mobile .module-tabs__year-filter-btn').html('全部');
                  } else {
                    $('.year-filter-mobile .module-tabs__year-filter-btn').html('ALL');  
                  }
                  
                }

                $('.media-card-result').each(function(){
                  var tab = $(this);
                  catID = tab.attr('data-cat-id');
                  $('.media-card-result').attr('data-page', '1');
                  // console.log(page);
                  page = 1;
                  result_target = tab.attr('id');

                  $('.media-card-result').empty();

                  load_posts_mobile(catID, page, result_target, year);
                  paginationInit_mobile(catID, page, result_target, year);
                });

              });


            });

          }
          yearFilter();


        };
        mediaTab_accordion_pagination();


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        var heroArrowBtn = function() {
          $('.btn-arrow').click(function(){
            $('html,body').animate({
              scrollTop: $('.hero__cards').offset().top - 55},
            'slow');
          });
        };

        heroArrowBtn();


        var pageBanner = function(){

          if($('.hero').length) {
            var w_height = $( window ).height();
            //var w_width = $( window ).width();
            $('.hero').css('height', w_height);  
          }
        };
        pageBanner();


         $(window).resize(function() {
          
            pageBanner();


            if ($(window).width() < 992 ) {

              if($('#mobile-menu__btn').is('.active')) {
                $('.mobile-menu').show();
                //$('.header__wrapper').addClass('no_shadow');
              } else {
                $('.mobile-menu').hide();
                //$('.header__wrapper').removeClass('no_shadow');
              }

            } else {
              $('.mobile-menu').hide();
              //$('.header__wrapper').removeClass('no_shadow');
            }
          
        });


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'page_template_template_careers': {
      init: function() {
       
        var allCareersBtn = function() {
          $('.btn__energy-header-solid').click(function(){
            $('html,body').animate({
              scrollTop: $('.module-career-list').offset().top - 55},
            'slow');
          });
        };

        allCareersBtn();

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
